export default (element) => {

  const init = () => {
    const menuToggles = element.querySelectorAll('[data-footer-menu-toggle]');
    menuToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const toggled = toggle.querySelector('svg').classList.toggle('!rotate-180');
        // eslint-disable-next-line no-param-reassign
        toggle.parentNode.querySelector('ul').style.maxHeight = toggled ? '1000px' : '0px'
      })
    })
  };

  init();
};
